export default __webpack_public_path__ + "files/media/SF-Ham-M.8e92fdec.jpg";